<div class="text_black border_wrapper h-100 powertrain_wrapper summaryBox">
  <div
    class="p-4 d-flex align-items-center justify-content-between text-black h_20"
    style="border-top-left-radius: 6px; border-top-right-radius: 6px"
  >
    <h4 class="font-weight-bolder powertrain_headers">
      <span>Powertrain Availability</span>
      <span
        style="cursor: pointer"
        class="material-icons info"
        ngbPopover="
        This is the total time for which the powertrain is available. It is calculated as the difference between the last commissioning date and total time for which the powertrain was in service
      "
        popoverClass="custom_popover"
        triggers="mouseenter:mouseleave"
        >info</span
      >
    </h4>
    <button mat-raised-button color="primary" (click)="openCommissionDate()">
      Update
    </button>
    <!-- <button
      mat-raised-button
      color="primary"
      (click)="updatePerformanceMetrics()"
    >
      Update
    </button> -->
  </div>
  <div class="d-flex h_80" style="justify-content: space-around">
    <div class="mt-2 ml-4 flex flex_50 gap_10">
      <div class="column_response_text_left w-100 h_20">
        Last Commissioning Date
      </div>
      <div class="column_response_text_left w-100 h_20">In Service Status</div>
      <div class="column_response_text_left w-100 h_20">
        Total Available Time
      </div>
      <!-- <div class="column_response_text_left w-100 h_20">Asset Availability</div>
      <div class="column_response_text_left w-100 h_20">Performance</div>
      <div class="column_response_text_left w-100 h_20">OEE*</div> -->
    </div>
    <div
      class="mt-2 mr-4 flex flex_50 gap_10"
      *ngIf="!performance_metrics_loader"
    >
      <div class="column_response_text_right h_20 w-100 text-center">
        @if (commission_date) {
        <span>{{ performance_metrics.last_commission_date }}</span>
        } @else {
        <!-- <button
          mat-raised-button
          color="primary"
          (click)="openCommissionDate()"
        >
          Update
        </button> -->
        N/A
        }
      </div>

      <div class="column_response_text_right h_20 w-100 text-center">
        <div class="text-center center_flex">
          <div class="toggle-container">
            <input
              type="checkbox"
              id="toggle"
              class="toggle-checkbox"
              (change)="toggleOn($event)"
              [checked]="isOutForService"
            />
            <label for="toggle" class="toggle-label"></label>
          </div>
        </div>
      </div>
      <div class="column_response_text_right h_20 w-100 text-center">
        {{ performance_metrics.availability_time }}
      </div>
    </div>
    <div
      class="mt-2 mr-4 flex flex_50 gap_10"
      *ngIf="performance_metrics_loader"
      style="gap: 16px"
    >
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
    </div>
  </div>
</div>

<app-powertrain-modal
  [type]="'performanceMetrics'"
  [data]="performance_metrics"
  *ngIf="showModal"
  (closeBox)="closeBox($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'commissionDate'"
  [subsystem_id]="subsystemId"
  *ngIf="openCommissionModal"
  (closeCommissionDate)="closeCommissionDate($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'out_of_service_pt'"
  [subsystem_id]="subsystemId"
  [data]="{isOutForService,last_record_id:performance_metrics.last_record_id}"
  *ngIf="showOFSModal"
  (closeOutForServiceModal)="closeOutForServiceModal($event)"
></app-powertrain-modal>
